import { useSelector } from "react-redux";
import type { RootState } from "@/store";

export const useExtractorPdfState = () =>
  useSelector((s: RootState) => s.extractorPdfIcms);
